import AuthContext from "context/AuthContext";
import { useContext } from "react";
import TableWasteMeasures from "./waste/TableWasteMeasures";
import TableBridgeMeasures from "./bridge/TableBridgeMeasures";

const TableMeasuresManager = (props) => {
    const { panel } = useContext(AuthContext);

    switch (panel.panel_type) {
        case 'b':
            return <TableBridgeMeasures {...props} />;
        default:
            return <TableWasteMeasures {...props} />;
    }
};
export default TableMeasuresManager;